import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import {
  Typography,
  Button,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { FileEditIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';

const SendForSignatureModal = ({ open, onClose, onSendForSignature }) => {
  return (
    <Modal
      title="Send for Signature"
      open={open}
      onClose={onClose}
      actions={
        <>
          <Button variant="text" color="primary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={onSendForSignature}
            startIcon={<FileEditIcon />}
          >
            Send for Signature
          </Button>
        </>
      }
      ModalProps={{
        PaperProps: {
          sx: {
            maxWidth: '600px',
          },
        },
      }}
    >
      <Typography variant="bodyMedium">
        Send the form to the applicant’s portal for electronic signing. They
        will receive a text message and email notifying them of the change. If
        they don’t yet have an account they’ll also receive an invitation to
        join.
      </Typography>
    </Modal>
  );
};

export default SendForSignatureModal;
